<template>
  <HeaderComponent :scrollTop="scrollTop" />
  <router-view />
  <FooterComponent />
</template>

<script>
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
export default {
  components: {
    HeaderComponent,
    FooterComponent,
  },
  data() {
    return {
      scrollTop: 0,
    };
  },
  mounted() {
    // Добавляем слушатель события scroll при монтировании компонента
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    // Удаляем слушатель при уничтожении компонента
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.scrollTop = window.pageYOffset;
    },
  },
};
</script>

<style>
:root {
  --m-color: 34, 50, 76;
  --s-color: 4, 157, 140;
}
body {
  margin: 0px;
  overflow-x: hidden;
}
.container {
  width: 1360px;
}

@media (max-width: 1400px) {
  .container {
    width: 1140px;
  }
}
@media (max-width: 1200px) {
  .container {
    width: 960px;
    padding: 0px 10px;
  }
}
p,
b,
a,
h1,
h2,
h3,
h4,
h5,
h6,
span,
button,
input,
textarea,
div,
header,
footer,
aside,
nav,
article,
svg,
path,
line,
citcle {
  margin: 0px;
  font-family: "Nunito", sans-serif;
  text-decoration: none;
  color: #212121;
  -webkit-transition: all 0.3s ease 0s;
  -moz-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}
button,
input,
textarea {
  background: transparent;
  border: 0px;
  cursor: pointer;
}
.flex {
  display: flex;
}
.gap-5 {
  gap: 5px;
}
.gap-10 {
  gap: 10px;
}
.gap-15 {
  gap: 15px;
}
.gap-20 {
  gap: 20px;
}
.gap-30 {
  gap: 30px;
}
.gap-40 {
  gap: 40px;
}
.ai-cneter {
  align-items: center;
}

.cols-1-1-1 {
  grid-template-columns: 1fr 1fr 1fr;
}

@media (max-width: 1200px) {
  .cols-1-1-1 {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 800px) {
  .cols-1-1-1 {
    grid-template-columns: 1fr;
  }
}

.btn-1 {
  height: 40px;
  text-align: center;
  box-shadow: 0 4px 5px 0 rgba(var(--m-color), 0.24);
  border: none;
  border-radius: 100px 10px 100px 10px;
  background-image: linear-gradient(
    135deg,
    rgb(var(--m-color)) 0%,
    rgb(var(--s-color)) 100%
  );
  font-weight: 700;
  font-size: 12px;
  color: #fff;
  letter-spacing: 0.75px;
  text-transform: uppercase;
  -webkit-transition: background 1s ease-out;
  -moz-transition: background 1s ease-out;
  -o-transition: background 1s ease-out;
  transition: background 1s ease-out;
  outline: none !important;
  cursor: pointer;
  position: relative;
  padding: 0px 30px;
  align-items: center;
  display: flex;
}
.btn-2.hovered svg,
.btn-2:hover svg {
  fill: white !important;
}
.btn-2.hovered p,
.btn-2:hover p {
  color: white !important;
  padding-left: 20px;
}
.btn-2.hovered span,
.btn-2:hover span {
  opacity: 1;
}
.btn-2 span {
  background-image: linear-gradient(
    135deg,
    rgb(var(--m-color)) 0%,
    rgb(var(--s-color)) 100%
  );
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  opacity: 0.00001;
  z-index: 1;
}
.btn-2 p {
  position: relative;
  z-index: 2;
  display: flex;
  gap: 3px;
  align-items: center;
}
.btn-2 p svg {
  width: 20px;
  height: 20px;
}
.btn-2 {
  width: 100%;
  margin: auto;
  display: inline-block;
  padding: 5px 0px;
  box-shadow: 0 4px 5px 0 rgba(var(--m-color), 0.24);
  border-radius: 100px 10px 100px 10px;
  background: #fff;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.88px;
  outline: none !important;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  text-align: start;
  padding-left: 40px;
  white-space: nowrap;
}
.btn-1:hover {
  background-image: linear-gradient(
    135deg,
    rgb(var(--s-color)) 0%,
    rgb(var(--m-color)) 100%
  );
}

.margin-la {
  margin-left: auto;
}

.grid {
  display: grid;
}

.t-1 {
  font-weight: 400;
  font-size: 16px;
  color: #697ba2;
  line-height: 28px;
  letter-spacing: 1px;
  margin-bottom: 40px;
  padding-bottom: 30px;
  position: relative;
}

.col-1-1 {
  grid-template-columns: 1fr 1fr;
}
@media (max-width: 1000px) {
  .col-1-1 {
    grid-template-columns: 1fr;
  }
}
</style>
